import { render, staticRenderFns } from "./BaseLinkList.vue?vue&type=template&id=042efb5a&"
import script from "./BaseLinkList.vue?vue&type=script&lang=js&"
export * from "./BaseLinkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports